module.exports = __webpack_public_path__ + "static/media/20.225b31e2.gif";